import { render, staticRenderFns } from "./ErrorTransfer.vue?vue&type=template&id=e510ed9a&scoped=true&"
import script from "./ErrorTransfer.vue?vue&type=script&lang=js&"
export * from "./ErrorTransfer.vue?vue&type=script&lang=js&"
import style0 from "./ErrorTransfer.vue?vue&type=style&index=0&id=e510ed9a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e510ed9a",
  null
  
)

export default component.exports